// Map of sectionId -> Splide instance, so we can destroy/re-mount on variant change
const featuredPackedSplides = {};

function mountFeaturedPackedSplide(el) {
  const sectionId = el.id.replace('featured-packed-splide-', '');

  // Destroy existing instance if re-mounting
  if (featuredPackedSplides[sectionId]) {
    try { featuredPackedSplides[sectionId].destroy(); } catch (e) {}
    delete featuredPackedSplides[sectionId];
  }

  const splide = new Splide(el, {
      type: 'loop',
      perPage: 3,
      gap: '34px',
      focus: 'center',
      padding: 0,
      pagination: true,
      arrows: true,
      trimSpace: true,
      updateOnMove: true,

      // Auto-scroll configuration
      autoplay: true,
      interval: 2500,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,

      // Fast and smooth transitions
      speed: 500,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',

      // Enhanced interaction
      drag: true,
      wheel: false,
      releaseWheel: true,

      breakpoints: {
        1024: {
          perPage: 2,
          gap: '34px',
          padding: 0,
          trimSpace: true,
          interval: 3000,
        },
        768: {
          perPage: 1,
          gap: '20px',
          padding: 0,
          trimSpace: true,
          interval: 3500,
        },
      },
    });

  splide.mount();

  // Store instance reference
  featuredPackedSplides[sectionId] = splide;

  initAutoScrollControls(splide, el);
  initIntersectionObserver(splide, el);
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide === 'undefined') return;

  document.querySelectorAll('[id^="featured-packed-splide-"]').forEach(mountFeaturedPackedSplide);

  // Subscribe to Dawn's variantChange pubsub event
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, handleFeaturedPackedVariantChange);
  }
});

function handleFeaturedPackedVariantChange(event) {
  const variant = event.data?.variant;
  if (!variant) return;

  document.querySelectorAll('[id^="featured-packed-"]').forEach(function (container) {
    // Skip the splide sub-element — only target the outer section container
    if (container.id.includes('splide')) return;

    const sectionId = container.dataset.sectionId;
    const productUrl = container.dataset.productUrl;
    if (!sectionId || !productUrl) return;

    // Fetch just this section re-rendered for the new variant
    fetch(`${productUrl}?section_id=${sectionId}&variant=${variant.id}`)
      .then(res => res.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        // Swap the slides list content only, keeping Splide's DOM wrapper intact
        const newList = parsed.querySelector('.splide__list');
        const currentList = container.querySelector('.splide__list');

        if (!newList || !currentList) {
          // No slides in the new variant — hide the section
          container.style.display = newList ? '' : 'none';
          return;
        }

        container.style.display = '';
        currentList.innerHTML = newList.innerHTML;

        // Re-mount Splide on the updated content
        const splideEl = container.querySelector('[id^="featured-packed-splide-"]');
        if (splideEl && typeof Splide !== 'undefined') {
          mountFeaturedPackedSplide(splideEl);

          // The new markup ships with data-src images — lazy-load them too.
          if (window.FeaturedPackedLazy) {
            window.FeaturedPackedLazy.observe(splideEl);
          }
        }
      })
      .catch(err => console.error('[featured-packed] variant fetch failed:', err));
  });
}

function initAutoScrollControls(splide, sliderElement) {
  if (!sliderElement) return;

  let isUserInteracting = false;
  let interactionTimeout;

  function pauseAutoScroll() {
    if (!isUserInteracting) {
      isUserInteracting = true;
      splide.Components.Autoplay.pause();
    }
    clearTimeout(interactionTimeout);
    interactionTimeout = setTimeout(() => {
      isUserInteracting = false;
      splide.Components.Autoplay.play();
    }, 8000);
  }

  sliderElement.addEventListener('mouseenter', () => {
    splide.Components.Autoplay.pause();
  });

  sliderElement.addEventListener('mouseleave', () => {
    if (!isUserInteracting) splide.Components.Autoplay.play();
  });

  sliderElement.addEventListener('touchstart', pauseAutoScroll);
  sliderElement.addEventListener('mousedown', pauseAutoScroll);

  sliderElement.querySelectorAll('.splide__arrow').forEach(arrow => {
    arrow.addEventListener('click', pauseAutoScroll);
  });

  sliderElement.querySelectorAll('.splide__pagination__page').forEach(dot => {
    dot.addEventListener('click', pauseAutoScroll);
  });

  sliderElement.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === ' ') {
      pauseAutoScroll();
    }
  });
}

function initIntersectionObserver(splide, sliderElement) {
  if (!('IntersectionObserver' in window) || !sliderElement) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        splide.Components.Autoplay.play();
      } else {
        splide.Components.Autoplay.pause();
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '50px'
  });

  observer.observe(sliderElement);
}


